<template>
    <label class="box" :class="[customClass, { 'is-active': shouldBeChecked}]" :tabindex="1">
        <input
            type="radio"
            :name="name"
            :value="value"
            :checked="shouldBeChecked"
            @change="updateInput"
        >
        <div class="box-content" v-html="title">
        </div>
        <div class="perspective"></div>
    </label>
</template>

<script>
export default {
  props: {
    customClass: String,
    title: String,
    index: Number,
    value: Number,
    modelValue: {
      default: '',
    },
    name: String,
  },
  computed: {
    shouldBeChecked() {
      return this.value === this.index;
    },
  },
  methods: {
    updateInput() {
      this.$emit('change', this.index);
    },
  },
};
</script>
